interface CacheItem<T> {
  data: T
  timestamp: number
  ttl: number
}

class ApiResponseCache {
  private cache = new Map<string, CacheItem<any>>()
  
  set<T>(key: string, data: T, ttlSeconds = 300): void {
    this.cache.set(key, {
      data,
      timestamp: Date.now(),
      ttl: ttlSeconds * 1000,
    })
  }
  
  get<T>(key: string): T | null {
    const item = this.cache.get(key)
    if (!item) return null
    
    if (Date.now() - item.timestamp > item.ttl) {
      this.cache.delete(key)
      return null
    }
    
    return item.data as T
  }
  
  invalidate(key: string): void {
    this.cache.delete(key)
  }
  
  invalidatePattern(pattern: string): void {
    const regex = new RegExp(pattern)
    Array.from(this.cache.keys())
      .filter(key => regex.test(key))
      .forEach(key => this.cache.delete(key))
  }
  
  clear(): void {
    this.cache.clear()
  }
}

export const apiCache = new ApiResponseCache()

// Helper to create cache keys
export const cacheKey = {
  heatmapData: () => 'heatmap-data',
  leavesByDate: (dateStart: string, dateEnd: string, status: string) => 
    `leaves-${dateStart}-${dateEnd}-${status}`,
  pendingForApprover: (approverId: string) => `pending-${approverId}`,
} 